export const GET_VISIT_SUCCESS = 'GET_VISIT_SUCCESS';
export const GET_VISIT_FAILURE = 'GET_VISIT_FAILURE';
export const GET_VISIT_REQUEST = 'GET_VISIT_REQUEST';
export const CLEAR_VISIT = 'CLEAR_VISIT';
